import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/about.jpg"
import about from "../assets/images/about.jpg"
import cta from "../assets/images/cta.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:FiAirplay,
            title:'Developing strategy',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:LiaReact,
            title:'Blazing performance',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:FiUsers,
            title:'Customer satisfaction',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
    ]
    const counterData = [
        {
            start:'0',
            end:'5458',
            title:'Investment Projects'
        },
        {
            start:'0',
            end:'15',
            title:'Years of Experience'
        },
        {
            start:'0',
            end:'54',
            title:'Offices in the World'
        },
        {
            start:'0',
            end:'214',
            title:'Successful Cases'
        },
    ]
    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section id="page-top" className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${bg1})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">Secure your legacy with clarity.</small>
                                <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Estate Planning Essentials</h5>
                            </div>
                        </div>
                    </div>
                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Estate Planning</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="section-title">
                                <p className="text-muted2">Creating an estate plan ensures that your assets and personal matters are handled according to your wishes, providing security and clarity for your loved ones. Below is a comprehensive, step-by-step guide to help you build a robust estate plan.</p>

                                <h4 className="title mt-5">Key Steps in an Estate Plan</h4>

                                <h5 className="mt-4">1. Inventory Your Assets</h5>
                                <ul>
                                    <li>Real Estate</li>
                                    <li>Financial Accounts</li>
                                    <li>Vehicles</li>
                                    <li>Personal Property</li>
                                    <li>Digital Assets</li>
                                </ul>

                                <h5 className="mt-4">2. List All Potential Beneficiaries</h5>
                                <p>Identify all beneficiaries with full legal names, addresses, and relationships. Update regularly as needed.</p>

                                <h5 className="mt-4">3. Develop Your Directives</h5>
                                <ul>
                                    <li>Asset Distribution</li>
                                    <li>Guardianship</li>
                                    <li>Healthcare Preferences</li>
                                    <li>Funeral Arrangements</li>
                                </ul>

                                <h5 className="mt-4">4. Designate Executor, Beneficiaries, and Trustees</h5>
                                <p>Choose responsible individuals to carry out your wishes and manage trusts if applicable.</p>

                                <h5 className="mt-4">5. Familiarize Yourself with Estate Taxes</h5>
                                <p>Understand both federal and state estate tax laws and strategies to minimize liabilities.</p>

                                <h5 className="mt-4">6. Organize Essential Information</h5>
                                <p>Store legal, financial, and contact information securely and ensure trusted individuals can access it.</p>

                                <h5 className="mt-4">7. Find an Estate Planning Professional</h5>
                                <p>Look for experienced, communicative professionals who align with your needs and values.</p>

                                <h5 className="mt-4">8. Execute Legal Documents</h5>
                                <p>Ensure all documents are legally valid, up-to-date, and accessible to necessary parties.</p>

                                <h4 className="title mt-5">Key Documents Needed in an Estate Plan</h4>
                                <ul>
                                    <li><strong>Will:</strong> Distributes assets and names guardians and executors.</li>
                                    <li><strong>Trust:</strong> Manages assets privately, avoids probate, and may reduce taxes.</li>
                                    <li><strong>Revocable Living Trust:</strong> Offers flexible, private asset control during life and after death.</li>
                                    <li><strong>Power of Attorney (POA):</strong> Grants authority to make financial or medical decisions on your behalf.</li>
                                    <li><strong>Advance Healthcare Directive:</strong> Documents your medical treatment preferences.</li>
                                </ul>

                                <h4 className="title mt-5">Leveraging TOD and POD in Your Estate Plan</h4>
                                <p><strong>Transfer on Death (TOD)</strong> and <strong>Payable on Death (POD)</strong> designations ensure assets are passed efficiently without going through probate.</p>

                                <h4 className="title mt-5">Considerations for Finding the Right Estate Planning Professional</h4>
                                <ul>
                                    <li>Specialization in estate planning and familiarity with relevant laws</li>
                                    <li>Strong track record and reputation</li>
                                    <li>Clear communication and transparent fees</li>
                                    <li>Comfortable working relationship</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="container mt-100 mt-60">
                        <div className="row justify-content-center">
                            {aboutData.map((item, index) => {
                                const Icon = item.icon;
                                return (
                                    <div className="col-lg-4 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0" key={index}>
                                        <div className="card shadow p-4 rounded features features-classic feature-primary">
                                            <Icon className="h1 mb-0 text-primary" />
                                            <div className="content my-3 border-bottom">
                                                <Link to="/page-single-service" className="title h5 text-dark">{item.title}</Link>
                                                <p className="text-muted2 mt-3">{item.desc}</p>
                                            </div>
                                            <Link to="/page-single-service" className="d-flex align-items-center justify-content-between">
                                                <span className="fw-medium text-dark">Read More</span>
                                                <FiArrowRight />
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}